import './style.scoped.css';
import iconBackBlack from 'src/assets/chevron_left_black.svg';
import iconCloseBlack from 'src/assets/close.svg';
import iconBackWhite from 'src/assets/chevron_left_white.svg';
import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';

type ToolbarProps = {
  title: string;
  onBack?: () => void;
  showBack?: boolean;
  showClose?: boolean;
  onClose?: () => void;
  type?: 'normal' | 'onPrimary';
  showLine?: boolean;
  titleKlass?: string
};

const Toolbar = (props: ToolbarProps) => {
  const {
    title,
    onBack,
    showBack = true,
    showClose,
    onClose,
    type = 'normal',
    titleKlass = ""
  } = props;
  const history = useHistory();

  const _handleBack = useCallback(() => {
    if (onBack) {
      onBack();
      return;
    }
    if (history.length >= 2) {
      history.goBack();
    }
  }, [history, onBack]);

  const _handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  return (
    <div
      className={
        type == 'onPrimary' ? 'toolbarContainerOnPrimary' : 'toolbarContainer'
      }
    >
      <div className="flex flex-row items-center justify-between relative w-full titleContainerNormal">
        {!!showBack && (
          <div
            onClick={_handleBack}
            className="w-6 h-6 flex justify-center items-center"
          >
            <img
              src={type == 'onPrimary' ? iconBackWhite : iconBackBlack}
              className="backIcon"
            />
          </div>
        )}
        {!!showClose && (
          <div
            onClick={_handleClose}
            className="w-6 h-6 flex justify-center items-center"
          >
            <img src={iconCloseBlack} className="w-6 h-6" />
          </div>
        )}
        <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center pointer-events-none">
          <div
            className={`${type == 'onPrimary' ? 'titleOnPrimary' : 'titleNormal'} ${titleKlass}`}
          >
            {title}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toolbar;
